const ACTION_TYPES = {
  PLATFORMS: 'PLATFORMS',
  OFFER_TYPES: 'OFFER_TYPES',
  APPLIED_FILTERS: 'APPLIED_FILTERS',
  TEMP_APPLIED_FILTERS: 'TEMP_APPLIED_FILTERS',
  OFFERS_LIST: 'OFFERS_LIST',
  FILTERS: 'FILTERS',
  CATEGORIES: 'CATEGORIES',
  URL_CID: 'URL_CID',
  BRANDS: 'BRANDS',
  IMAGES_LAODING: 'IMAGES_LOADING',
};

export default ACTION_TYPES;
